import { FaWhatsapp } from "react-icons/fa6";

const WhatsAppFloat = () => {
  return (
    <a
      href={`https://wa.me/905063853685?text=${encodeURIComponent('Merhaba, hizmetleriniz ile bilgi almak istiyorum.')}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      className="whatsapp-float"
      aria-label="WhatsApp ile iletişime geç"
    >
      <FaWhatsapp size={31} className="text-white-500" />
    </a>
  );
};

export default WhatsAppFloat;
